






















import { Prop } from 'vue-property-decorator';
import { IsPropMixin, NamespacedTranslationMixin } from '@pwr/common-components';
import Component, { mixins } from 'vue-class-component';
import PwrLangItem from '@/components/Pwr/PwrLangSelector/PwrLangItem.vue';
import PwrLangList from '@/components/Pwr/PwrLangSelector/PwrLangList.vue';

@Component({
  components: { PwrLangList, PwrLangItem }
})
export default class PwrLangSelector extends mixins(NamespacedTranslationMixin, IsPropMixin) {
  @Prop({ default: () => [] }) languages!: string[];
  @Prop({
    default: () => Object()
  })
  flags: any;

  get cleanLocales(): [] {
    return this.flags;
  }

  private getFlag(lang: string) {
    if (this.flags[lang]) {
      return this.flags[lang];
    }
    return 'flagEmpty';
  }

  private async updateLang(lang: string) {
    localStorage.setItem('lang', lang);
    window.location.reload();
  }
}
